export const supressLeadingZeros = (value: string | null | undefined, filterOut: boolean) => {
  if (value == null) {
    return '';
  }

  const onlyNumbers = value.match(/^[0-9]*$/);

  if (!onlyNumbers && filterOut) {
    return value;
  }

  return filterOut ? value.replace(/^0+/, '') : value.match(/^0+/);
};
